module.exports = __webpack_public_path__ + "static/media/usuario.134e8b79.svg";